import { useClerk } from '@clerk/remix'
import { useEffect } from 'react'

// ログイン状態が不正な場合に強引にログアウトする

export async function loader() {
	console.log('📍 /sign-out loader 実行開始')
	// サーバー側でのセッション無効化はしない
	// クライアント側のsignOut()だけで完結させる
	console.log('📍 /sign-out loader 完了')
	return null
	// return redirect('/', {
	// 	headers: {
	// 		'Set-Cookie':
	// 			'__session=; Path=/; Expires=Thu, 01 Jan 1970 00:00:00 GMT; HttpOnly; Secure; SameSite=Lax',
	// 	},
	// })
}

export default function SignOutClient() {
	const { signOut } = useClerk()

	useEffect(() => {
		const performSignOut = async () => {
			console.log('🔄 サインアウト処理開始')
			try {
				console.log('🔄 signOut実行中...')
				await signOut()
				console.log('✅ signOut完了')

				// 少し待ってからリダイレクト（signOutの処理が完全に終わるのを待つ）
				await new Promise(resolve => setTimeout(resolve, 1000))

				console.log('🔄 リダイレクト実行')
				// URLパラメータを取得してリダイレクト先に引き継ぐ
				const params = new URLSearchParams(window.location.search)
				const redirectTo = params.get('redirectTo') || '/'
				console.log('🔄 リダイレクト先:', redirectTo)
				window.location.href = redirectTo
			} catch (error) {
				console.error('❌ Sign out error:', error)
				console.log('🔄 強制リダイレクト実行')
				// エラーが発生してもリダイレクト
				window.location.href = '/'
			}
		}
		performSignOut()
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	return <div>サインアウト中...</div>
}
